module.exports = __webpack_public_path__ + "static/media/spooky.5a241176.jpg";